import { render, staticRenderFns } from "./horizontal-scrollbar.vue?vue&type=template&id=a47f62e0&"
import script from "./horizontal-scrollbar.vue?vue&type=script&lang=js&"
export * from "./horizontal-scrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports